var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponent83(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_83_1",
    "data-name": "Component 83 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 328,
    height: 328,
    viewBox: "0 0 328 328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 328,
    height: 328,
    rx: 164,
    fill: "#f8f8f8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3497641",
    "data-name": 3497641,
    transform: "translate(9.683 -5.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(0 54.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16177",
    "data-name": "Group 16177"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 308.634,
    height: 0.154,
    transform: "translate(0 202.124)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 13.092,
    height: 0.154,
    transform: "translate(32.382 208.001)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 52.449,
    height: 0.154,
    transform: "translate(105.639 206.328)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 23.524,
    height: 0.154,
    transform: "translate(41.77 213.735)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 26.66,
    height: 0.154,
    transform: "translate(251.049 212.698)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 7.389,
    height: 0.154,
    transform: "translate(241.642 212.698)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 14.197,
    height: 0.154,
    transform: "translate(214.741 210.093)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 29.9,
    height: 0.154,
    transform: "translate(177.705 210.093)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47784",
    "data-name": "Path 47784",
    d: "M160.919,229.544H41.725A3.527,3.527,0,0,1,38.2,226.02V58.475a3.527,3.527,0,0,1,3.525-3.525H160.919a3.527,3.527,0,0,1,3.525,3.525V226.02A3.527,3.527,0,0,1,160.919,229.544ZM41.725,55.1a3.375,3.375,0,0,0-3.37,3.37V226.02a3.375,3.375,0,0,0,3.37,3.37H160.919a3.375,3.375,0,0,0,3.37-3.37V58.475a3.375,3.375,0,0,0-3.37-3.37Z",
    transform: "translate(-14.62 -54.95)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47785",
    "data-name": "Path 47785",
    d: "M377.219,229.544H258.025a3.527,3.527,0,0,1-3.525-3.525V58.475a3.527,3.527,0,0,1,3.525-3.525H377.219a3.527,3.527,0,0,1,3.525,3.525V226.02A3.527,3.527,0,0,1,377.219,229.544ZM258.025,55.1a3.375,3.375,0,0,0-3.37,3.37V226.02a3.375,3.375,0,0,0,3.37,3.37H377.219a3.375,3.375,0,0,0,3.37-3.37V58.475a3.375,3.375,0,0,0-3.37-3.37Z",
    transform: "translate(-97.405 -54.95)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16188",
    "data-name": "Group 16188",
    transform: "translate(45.202 13.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16180",
    "data-name": "Group 16180",
    transform: "translate(0 114.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16178",
    "data-name": "Group 16178",
    transform: "translate(1.105 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 9.506,
    height: 73.159,
    transform: "translate(9.512 73.159) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 83.201,
    height: 73.159,
    transform: "translate(9.512)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 73.047,
    height: 39.129,
    transform: "translate(20.419 27.61)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 73.047,
    height: 12.882,
    transform: "translate(20.419 10.574)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 0.654,
    height: 39.129,
    transform: "translate(20.419 66.739) rotate(180)",
    fill: "#e6e6e6",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 0.654,
    height: 12.882,
    transform: "translate(20.419 23.456) rotate(180)",
    fill: "#e6e6e6",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 92.917,
    height: 1.654,
    transform: "translate(92.917 4.741) rotate(180)",
    fill: "#e6e6e6",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16179",
    "data-name": "Group 16179"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 10.617,
    height: 4.784,
    transform: "translate(10.617 4.784) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 84.313,
    height: 4.784,
    transform: "translate(10.617)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16183",
    "data-name": "Group 16183",
    transform: "translate(11.148 76.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16181",
    "data-name": "Group 16181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47786",
    "data-name": "Path 47786",
    d: "M130.276,229.338a5.024,5.024,0,0,1-.9-2.574,8.11,8.11,0,0,1,.241-2.778,12.878,12.878,0,0,1,2.531-4.876A22.525,22.525,0,0,1,134,217.129c.339-.29.679-.586,1.025-.864a11.259,11.259,0,0,1,1.062-.815,26.086,26.086,0,0,1,2.265-1.407c.8-.389,1.593-.784,2.426-1.093-.58.691-1.21,1.3-1.827,1.907s-1.2,1.241-1.821,1.827-1.16,1.235-1.753,1.827c-.284.309-.543.63-.821.944a10.555,10.555,0,0,0-.8.951,18.992,18.992,0,0,0-2.611,4.1,11.015,11.015,0,0,0-.765,2.309,6.923,6.923,0,0,0-.1,2.531Z",
    transform: "translate(-105.857 -205.376)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47787",
    "data-name": "Path 47787",
    d: "M101.284,227.039a6.664,6.664,0,0,0,.4-2.29,6.9,6.9,0,0,0-.08-1.08,7.658,7.658,0,0,0-.29-1.012,9.624,9.624,0,0,0-2.463-3.438c-.259-.259-.568-.481-.852-.728a8.153,8.153,0,0,0-.877-.71c-.63-.432-1.2-.944-1.876-1.346-.327-.216-.648-.432-.975-.66s-.642-.463-.988-.667A24,24,0,0,1,91.29,213.7a23.2,23.2,0,0,1,2.414.488,7.857,7.857,0,0,1,1.173.377c.383.142.765.3,1.148.457l.574.241c.185.086.364.2.549.3.364.2.722.414,1.086.623a8.484,8.484,0,0,1,1.037.728c.327.272.673.512.988.815a8.355,8.355,0,0,1,2.617,4.543,2.756,2.756,0,0,1,.062.679c0,.228.019.451,0,.673a6.026,6.026,0,0,1-.272,1.3,4.66,4.66,0,0,1-1.389,2.111Z",
    transform: "translate(-91.29 -205.663)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47788",
    "data-name": "Path 47788",
    d: "M103.563,224.873a14.12,14.12,0,0,0,.117-4.975,13.19,13.19,0,0,0-1.562-4.432l-.617-1.018c-.228-.327-.488-.636-.722-.963l-.358-.494-.414-.451c-.278-.3-.543-.611-.815-.926-.58-.586-1.191-1.167-1.778-1.784-.636-.568-1.278-1.136-1.9-1.79a25.193,25.193,0,0,1,2.469.963,25.542,25.542,0,0,1,2.272,1.4q.518.426,1.037.87l.512.451.457.512c.3.346.6.691.889,1.049l.741,1.173a10.5,10.5,0,0,1,1.377,5.352,8.382,8.382,0,0,1-1.722,5.068Z",
    transform: "translate(-92.909 -203.497)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47789",
    "data-name": "Path 47789",
    d: "M125.853,222.97a24.27,24.27,0,0,1-3.1-5.006,33.087,33.087,0,0,1-2.031-5.543,27.673,27.673,0,0,1-.858-5.876,16.653,16.653,0,0,1,.9-5.864c.173,1.975.389,3.846.71,5.71.358,1.858.772,3.691,1.235,5.518.481,1.827,1.006,3.648,1.543,5.488s1.093,3.673,1.6,5.586Z",
    transform: "translate(-102.224 -200.68)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47790",
    "data-name": "Path 47790",
    d: "M122.656,222.714a27.761,27.761,0,0,1-3.913-4.679,38.37,38.37,0,0,1-3.006-5.309,31.686,31.686,0,0,1-2.018-5.79,18.75,18.75,0,0,1-.444-6.117c.623,1.957,1.265,3.809,1.981,5.636.735,1.827,1.531,3.617,2.339,5.407.827,1.79,1.679,3.568,2.537,5.364s1.716,3.6,2.518,5.481Z",
    transform: "translate(-99.669 -200.734)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47791",
    "data-name": "Path 47791",
    d: "M123.9,228.17a28.041,28.041,0,0,1-4.858-3.685,38.443,38.443,0,0,1-4.117-4.5,32.025,32.025,0,0,1-3.259-5.191,18.618,18.618,0,0,1-1.8-5.864c1.043,1.772,2.08,3.426,3.191,5.055s2.3,3.185,3.488,4.753c1.2,1.556,2.432,3.1,3.667,4.66s2.475,3.123,3.679,4.778Z",
    transform: "translate(-98.401 -203.838)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47792",
    "data-name": "Path 47792",
    d: "M118.531,224.8a21.271,21.271,0,0,1-4.667-3.16A28.718,28.718,0,0,1,110,217.52a24.776,24.776,0,0,1-2.907-4.876,16.4,16.4,0,0,1-1.383-5.494c.944,1.648,1.809,3.222,2.8,4.734s2.018,2.969,3.117,4.395,2.222,2.833,3.383,4.241,2.339,2.809,3.518,4.284Z",
    transform: "translate(-96.809 -203.156)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47793",
    "data-name": "Path 47793",
    d: "M129.738,228.479a6.183,6.183,0,0,1-2.543-4.241,8.9,8.9,0,0,1,.8-5.037l.259-.58.315-.543.66-1.062q.38-.491.778-.963a9.625,9.625,0,0,1,.821-.914,21.46,21.46,0,0,1,1.846-1.593,22.374,22.374,0,0,1,2.062-1.278,23.746,23.746,0,0,1-1.339,1.988c-.457.636-.864,1.3-1.315,1.907-.426.636-.8,1.284-1.21,1.907l-.519.981-.265.481-.21.5a10.745,10.745,0,0,0-1.074,4.1,8.934,8.934,0,0,0,.938,4.339Z",
    transform: "translate(-104.998 -205.116)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47794",
    "data-name": "Path 47794",
    d: "M127.644,224.934a9.874,9.874,0,0,1-2.617-4.395,9.71,9.71,0,0,1-.074-5.315,9,9,0,0,1,1.086-2.481,9.718,9.718,0,0,1,1.691-2.049,11.027,11.027,0,0,1,4.426-2.543,32.559,32.559,0,0,0-3.222,3.623,12.978,12.978,0,0,0-1.2,1.932,9.752,9.752,0,0,0-.8,2.062,12.187,12.187,0,0,0-.327,4.457,22.7,22.7,0,0,0,1.037,4.71Z",
    transform: "translate(-104.045 -203.539)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47795",
    "data-name": "Path 47795",
    d: "M118.64,227.221l-9.66-9.271.389,9.092Z",
    transform: "translate(-98.061 -207.29)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16182",
    "data-name": "Group 16182",
    transform: "translate(5.475 18.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47796",
    "data-name": "Path 47796",
    d: "M125.82,231.37H100.16l3.358,19.067h18.944Z",
    transform: "translate(-100.16 -231.37)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47797",
    "data-name": "Path 47797",
    d: "M109.789,231.37H100.16l3.358,19.067h5.062Z",
    transform: "translate(-100.16 -231.37)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16184",
    "data-name": "Group 16184",
    transform: "translate(17.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 51.795,
    height: 65.109,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 61.245,
    height: 65.109,
    transform: "translate(1.988)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 54.85,
    height: 50.986,
    transform: "translate(7.117 59.974) rotate(-90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16187",
    "data-name": "Group 16187",
    transform: "translate(137.793 58.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16185",
    "data-name": "Group 16185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47798",
    "data-name": "Path 47798",
    d: "M382.248,301.624H303.454L296.46,171.35h78.794Z",
    transform: "translate(-296.46 -171.35)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47799",
    "data-name": "Path 47799",
    d: "M386.148,301.624H307.354L300.36,171.35h78.794Z",
    transform: "translate(-297.953 -171.35)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16186",
    "data-name": "Group 16186",
    transform: "translate(23.024 13.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47800",
    "data-name": "Path 47800",
    d: "M370.957,296.518H363.92l.284-103.4h7.037Z",
    transform: "translate(-345.303 -193.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47801",
    "data-name": "Path 47801",
    d: "M401.107,296.518H394.07l.29-103.4h7.031Z",
    transform: "translate(-356.843 -193.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47802",
    "data-name": "Path 47802",
    d: "M340.8,296.518H333.76l.29-103.4h7.037Z",
    transform: "translate(-333.76 -193.12)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    transform: "translate(34.635 270.975)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_lt_Path_gt_",
    "data-name": "&lt;Path&gt;",
    cx: 119.682,
    cy: 6.987,
    rx: 119.682,
    ry: 6.987,
    transform: "translate(0 0)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sliders",
    transform: "translate(146.045 75.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16193",
    "data-name": "Group 16193",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16189",
    "data-name": "Group 16189"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 14.555,
    height: 0.617,
    transform: "translate(91.902 141.132) rotate(-86.86)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 7.5,
    height: 0.617,
    transform: "translate(92.969 121.759) rotate(-86.86)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47804",
    "data-name": "Path 47804",
    d: "M349.628,257.835H244.606a7.945,7.945,0,0,1-7.994-8.457l8.333-151.922A9.067,9.067,0,0,1,253.865,89H358.887a7.945,7.945,0,0,1,7.994,8.457l-8.333,151.922a9.067,9.067,0,0,1-8.92,8.457Z",
    transform: "translate(-236.6 -89)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47803",
    "data-name": "Path 47803",
    d: "M347.835,257.835H244.616a7.945,7.945,0,0,1-7.994-8.457l8.333-151.922A9.067,9.067,0,0,1,253.875,89H357.094a7.945,7.945,0,0,1,7.994,8.457l-8.333,151.922A9.067,9.067,0,0,1,347.835,257.835Z",
    transform: "translate(-236.603 -89)",
    fill: "#7aa3ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47805",
    "data-name": "Path 47805",
    d: "M290.927,129.188H271.4a3.357,3.357,0,0,1-3.376-3.574h0a3.831,3.831,0,0,1,3.765-3.574h19.524a3.357,3.357,0,0,1,3.376,3.574h0A3.831,3.831,0,0,1,290.927,129.188Z",
    transform: "translate(-248.626 -101.645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47806",
    "data-name": "Path 47806",
    d: "M303.255,123.846a6.871,6.871,0,0,1-6.778,6.426,6.017,6.017,0,0,1-6.074-6.426,6.871,6.871,0,0,1,6.778-6.426A6.017,6.017,0,0,1,303.255,123.846Z",
    transform: "translate(-257.188 -99.877)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47807",
    "data-name": "Path 47807",
    d: "M288.9,166.2H269.373A3.357,3.357,0,0,1,266,162.624h0a3.831,3.831,0,0,1,3.765-3.574h19.524a3.357,3.357,0,0,1,3.376,3.574h0A3.831,3.831,0,0,1,288.9,166.2Z",
    transform: "translate(-247.849 -115.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16190",
    "data-name": "Group 16190",
    transform: "translate(23.329 40.388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47808",
    "data-name": "Path 47808",
    d: "M287.255,160.856a6.871,6.871,0,0,1-6.778,6.426,6.017,6.017,0,0,1-6.074-6.426,6.871,6.871,0,0,1,6.778-6.426A6.017,6.017,0,0,1,287.255,160.856Z",
    transform: "translate(-274.394 -154.43)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47809",
    "data-name": "Path 47809",
    d: "M287.255,160.856a6.871,6.871,0,0,1-6.778,6.426,6.017,6.017,0,0,1-6.074-6.426,6.871,6.871,0,0,1,6.778-6.426A6.017,6.017,0,0,1,287.255,160.856Z",
    transform: "translate(-274.394 -154.43)",
    fill: "#fafafa",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47810",
    "data-name": "Path 47810",
    d: "M265.313,240.218h19.524a3.826,3.826,0,0,0,3.765-3.574h0a3.361,3.361,0,0,0-3.376-3.574H265.7a3.826,3.826,0,0,0-3.765,3.574h0A3.361,3.361,0,0,0,265.313,240.218Z",
    transform: "translate(-246.295 -144.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16191",
    "data-name": "Group 16191",
    transform: "translate(15.632 86.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47811",
    "data-name": "Path 47811",
    d: "M261.934,234.876a6.017,6.017,0,0,0,6.074,6.426,6.867,6.867,0,0,0,6.778-6.426,6.017,6.017,0,0,0-6.074-6.426A6.867,6.867,0,0,0,261.934,234.876Z",
    transform: "translate(-261.924 -228.45)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47812",
    "data-name": "Path 47812",
    d: "M261.934,234.876a6.017,6.017,0,0,0,6.074,6.426,6.867,6.867,0,0,0,6.778-6.426,6.017,6.017,0,0,0-6.074-6.426A6.867,6.867,0,0,0,261.934,234.876Z",
    transform: "translate(-261.924 -228.45)",
    fill: "#fafafa",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47813",
    "data-name": "Path 47813",
    d: "M282.807,277.228H263.283a3.357,3.357,0,0,1-3.376-3.574h0a3.831,3.831,0,0,1,3.765-3.574H283.2a3.357,3.357,0,0,1,3.376,3.574h0A3.831,3.831,0,0,1,282.807,277.228Z",
    transform: "translate(-245.518 -158.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47814",
    "data-name": "Path 47814",
    d: "M295.135,271.886a6.871,6.871,0,0,1-6.778,6.426,6.017,6.017,0,0,1-6.074-6.426,6.873,6.873,0,0,1,6.784-6.426,6.014,6.014,0,0,1,6.074,6.426Z",
    transform: "translate(-254.081 -156.537)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47815",
    "data-name": "Path 47815",
    d: "M267.343,203.208h19.524a3.826,3.826,0,0,0,3.765-3.574h0a3.361,3.361,0,0,0-3.376-3.574H267.732a3.826,3.826,0,0,0-3.765,3.574h0A3.361,3.361,0,0,0,267.343,203.208Z",
    transform: "translate(-247.072 -129.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16192",
    "data-name": "Group 16192",
    transform: "translate(16.891 63.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47816",
    "data-name": "Path 47816",
    d: "M263.974,197.866a6.017,6.017,0,0,0,6.074,6.426,6.867,6.867,0,0,0,6.778-6.426,6.017,6.017,0,0,0-6.074-6.426A6.867,6.867,0,0,0,263.974,197.866Z",
    transform: "translate(-263.964 -191.44)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47817",
    "data-name": "Path 47817",
    d: "M263.974,197.866a6.017,6.017,0,0,0,6.074,6.426,6.867,6.867,0,0,0,6.778-6.426,6.017,6.017,0,0,0-6.074-6.426A6.867,6.867,0,0,0,263.974,197.866Z",
    transform: "translate(-263.964 -191.44)",
    fill: "#fafafa",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47818",
    "data-name": "Path 47818",
    d: "M386.491,124.332h-59.8a1.343,1.343,0,0,1-1.352-1.426h0a1.532,1.532,0,0,1,1.506-1.426h59.8A1.343,1.343,0,0,1,388,122.906h0A1.532,1.532,0,0,1,386.491,124.332Z",
    transform: "translate(-270.562 -101.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47819",
    "data-name": "Path 47819",
    d: "M345.818,132.432H326.25a1.343,1.343,0,0,1-1.352-1.426h0a1.532,1.532,0,0,1,1.506-1.426h19.567a1.343,1.343,0,0,1,1.352,1.426h0A1.532,1.532,0,0,1,345.818,132.432Z",
    transform: "translate(-270.394 -104.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47820",
    "data-name": "Path 47820",
    d: "M374.721,272.372H318.58a1.343,1.343,0,0,1-1.352-1.426h0a1.532,1.532,0,0,1,1.506-1.426h56.141a1.343,1.343,0,0,1,1.352,1.426h0A1.532,1.532,0,0,1,374.721,272.372Z",
    transform: "translate(-267.458 -158.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47821",
    "data-name": "Path 47821",
    d: "M330.624,280.462H318.13a1.343,1.343,0,0,1-1.352-1.426h0a1.532,1.532,0,0,1,1.506-1.426h12.493a1.343,1.343,0,0,1,1.352,1.426h0A1.532,1.532,0,0,1,330.624,280.462Z",
    transform: "translate(-267.286 -161.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47822",
    "data-name": "Path 47822",
    d: "M384.176,166.58h-59.8a1.532,1.532,0,0,0-1.506,1.426h0a1.339,1.339,0,0,0,1.352,1.426h59.8a1.532,1.532,0,0,0,1.506-1.426h0A1.339,1.339,0,0,0,384.176,166.58Z",
    transform: "translate(-269.617 -118.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47823",
    "data-name": "Path 47823",
    d: "M344.392,158.48H324.825a1.532,1.532,0,0,0-1.506,1.426h0a1.339,1.339,0,0,0,1.352,1.426h19.567a1.532,1.532,0,0,0,1.506-1.426h0A1.339,1.339,0,0,0,344.392,158.48Z",
    transform: "translate(-269.789 -115.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47824",
    "data-name": "Path 47824",
    d: "M337.48,198.352H322.64a1.343,1.343,0,0,1-1.352-1.426h0a1.532,1.532,0,0,1,1.506-1.426h14.839a1.343,1.343,0,0,1,1.352,1.426h0A1.532,1.532,0,0,1,337.48,198.352Z",
    transform: "translate(-269.012 -129.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47825",
    "data-name": "Path 47825",
    d: "M364.091,198.352H355.35A1.343,1.343,0,0,1,354,196.926h0A1.532,1.532,0,0,1,355.5,195.5h8.741a1.343,1.343,0,0,1,1.352,1.426h0A1.532,1.532,0,0,1,364.091,198.352Z",
    transform: "translate(-281.531 -129.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47826",
    "data-name": "Path 47826",
    d: "M341.758,206.442H322.19a1.343,1.343,0,0,1-1.352-1.426h0a1.532,1.532,0,0,1,1.506-1.426h19.567a1.343,1.343,0,0,1,1.352,1.426h0A1.532,1.532,0,0,1,341.758,206.442Z",
    transform: "translate(-268.84 -132.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47827",
    "data-name": "Path 47827",
    d: "M293.167,312.22h-33.32a1.878,1.878,0,0,1-1.889-2h0a2.143,2.143,0,0,1,2.1-2h33.32a1.878,1.878,0,0,1,1.889,2h0A2.143,2.143,0,0,1,293.167,312.22Z",
    transform: "translate(-244.773 -172.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47828",
    "data-name": "Path 47828",
    d: "M380.147,312.22h-51.32a1.878,1.878,0,0,1-1.889-2h0a2.143,2.143,0,0,1,2.1-2h51.32a1.878,1.878,0,0,1,1.889,2h0a2.143,2.143,0,0,1-2.1,2Z",
    transform: "translate(-271.174 -172.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47829",
    "data-name": "Path 47829",
    d: "M327.805,323.55H259.227a1.878,1.878,0,0,1-1.889-2h0a2.143,2.143,0,0,1,2.1-2h68.578a1.878,1.878,0,0,1,1.889,2h0A2.143,2.143,0,0,1,327.805,323.55Z",
    transform: "translate(-244.536 -177.239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47830",
    "data-name": "Path 47830",
    d: "M348.944,334.88H258.607a1.878,1.878,0,0,1-1.889-2h0a2.143,2.143,0,0,1,2.1-2H349.16a1.878,1.878,0,0,1,1.889,2h0A2.143,2.143,0,0,1,348.944,334.88Z",
    transform: "translate(-244.298 -181.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47831",
    "data-name": "Path 47831",
    d: "M328.882,240.6h-8.568a1.532,1.532,0,0,0-1.506,1.426h0a1.339,1.339,0,0,0,1.352,1.426h8.568a1.532,1.532,0,0,0,1.506-1.426h0A1.339,1.339,0,0,0,328.882,240.6Z",
    transform: "translate(-268.063 -147.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47832",
    "data-name": "Path 47832",
    d: "M352.8,240.6h-9.932a1.532,1.532,0,0,0-1.506,1.426h0a1.339,1.339,0,0,0,1.352,1.426h9.932a1.532,1.532,0,0,0,1.506-1.426h0A1.339,1.339,0,0,0,352.8,240.6Z",
    transform: "translate(-276.694 -147.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47833",
    "data-name": "Path 47833",
    d: "M377.368,232.5h-56.6a1.532,1.532,0,0,0-1.506,1.426h0a1.339,1.339,0,0,0,1.352,1.426h56.6a1.532,1.532,0,0,0,1.506-1.426h0A1.339,1.339,0,0,0,377.368,232.5Z",
    transform: "translate(-268.235 -143.922)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(68.102 94.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16196",
    "data-name": "Group 16196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47834",
    "data-name": "Path 47834",
    d: "M167.421,170.256c-2.018,1.679-4.1,3.494-6.018,5.321-.963.92-1.907,1.858-2.772,2.815a23.226,23.226,0,0,0-2.309,2.895l-.117.173-.062.1c-.043.049-.08.167-.13.247-.086.191-.167.432-.253.685a12.605,12.605,0,0,0-.383,1.716,36.467,36.467,0,0,0-.377,3.883c-.13,2.673-.13,5.45-.08,8.173l-2.889.432a52.535,52.535,0,0,1-1.481-8.518,32.577,32.577,0,0,1-.1-4.481,17.3,17.3,0,0,1,.29-2.42,10.044,10.044,0,0,1,.352-1.321,7.077,7.077,0,0,1,.284-.71l.173-.37c.056-.117.1-.185.154-.278a25.32,25.32,0,0,1,2.63-3.858c.938-1.179,1.926-2.259,2.944-3.309a63.184,63.184,0,0,1,6.494-5.808l3.642,4.636Z",
    transform: "translate(-125.668 -136.783)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47835",
    "data-name": "Path 47835",
    d: "M171.324,160.827c-3.16,1.876-7.944,6.666-7.944,6.666l5.864,7.031s8.315-4.981,9.321-7.734c1.7-4.623-4.253-7.734-7.241-5.963Z",
    transform: "translate(-130.633 -134.756)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47836",
    "data-name": "Path 47836",
    d: "M155.48,213.448l.716,4.185-3.883-.562s-.8-2.839,1.21-3.821l1.957.2Z",
    transform: "translate(-126.338 -155.013)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47837",
    "data-name": "Path 47837",
    d: "M154.214,222.535l-3.494-1.086,1.043-2.018,3.883.562Z",
    transform: "translate(-125.788 -157.378)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47838",
    "data-name": "Path 47838",
    d: "M214.32,136.749c0,.426.241.772.519.778s.506-.34.5-.759-.241-.772-.519-.778S214.314,136.329,214.32,136.749Z",
    transform: "translate(-150.129 -125.443)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47839",
    "data-name": "Path 47839",
    d: "M214.92,135.848l1.025-.278S215.426,136.36,214.92,135.848Z",
    transform: "translate(-150.359 -125.282)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47840",
    "data-name": "Path 47840",
    d: "M214.91,137.9a11.715,11.715,0,0,0,1.568,2.734,1.833,1.833,0,0,1-1.525.265l-.043-2.994Z",
    transform: "translate(-150.355 -126.174)",
    fill: "#a02724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47841",
    "data-name": "Path 47841",
    d: "M213.726,132.264a.425.425,0,0,1-.123-.006,2.074,2.074,0,0,0-1.833.216.251.251,0,0,1-.3-.4,2.582,2.582,0,0,1,2.3-.29.252.252,0,0,1,.16.315.239.239,0,0,1-.191.167Z",
    transform: "translate(-148.999 -123.778)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47842",
    "data-name": "Path 47842",
    d: "M191.957,144.56c.284,3.191-.784,8.42-3.2,10.2,0,0,1.815,3.358,7.636,4.136,6.395.858,3.389-2.741,3.389-2.741-3.4-1.3-3.037-3.858-2.173-6.185Z",
    transform: "translate(-140.347 -128.723)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47843",
    "data-name": "Path 47843",
    d: "M211.3,167c3.043.833,6.241,1.63,9.376,2.333,1.58.346,3.16.654,4.741.957,1.58.278,3.167.556,4.741.759l.593.08.4.043a7.95,7.95,0,0,0,.932-.012,15.262,15.262,0,0,0,2.13-.29,43.378,43.378,0,0,0,4.525-1.185c3.043-.957,6.136-2.1,9.148-3.284l1.37,2.574a65.509,65.509,0,0,1-8.932,4.895,39.8,39.8,0,0,1-4.926,1.839,19.915,19.915,0,0,1-2.747.617,14.99,14.99,0,0,1-1.543.13c-.272,0-.58-.006-.833-.019l-.642-.043a81.04,81.04,0,0,1-10.129-1.346,94.626,94.626,0,0,1-9.9-2.4l1.691-5.642Z",
    transform: "translate(-148.323 -137.082)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47844",
    "data-name": "Path 47844",
    d: "M270.37,166.217l.9-3.037,3.29,1.235s-.753,4.555-3.574,3.3l-.611-1.5Z",
    transform: "translate(-171.582 -135.849)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47845",
    "data-name": "Path 47845",
    d: "M273.727,159.93l3.358.377-1.975,2.87-3.29-1.235Z",
    transform: "translate(-172.137 -134.605)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47846",
    "data-name": "Path 47846",
    d: "M178.64,399.338l5.29.4,1.574-12.154-5.29-.389Z",
    transform: "translate(-136.474 -221.585)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47847",
    "data-name": "Path 47847",
    d: "M115.44,364.422l3.592,3.988,10.037-6.938-3.592-3.981Z",
    transform: "translate(-112.285 -210.218)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47848",
    "data-name": "Path 47848",
    d: "M124.652,377.426a.689.689,0,0,1-.191-.031c-.642-.21-1.08-1.4-1.284-2.086a.13.13,0,0,1,.043-.136.121.121,0,0,1,.136-.012c.191.1,1.9,1.025,1.951,1.7a.426.426,0,0,1-.179.383.787.787,0,0,1-.475.179Zm-1.142-1.9c.3.914.679,1.506,1.025,1.623a.453.453,0,0,0,.432-.1.192.192,0,0,0,.086-.167C125.023,376.525,124.177,375.92,123.511,375.531Z",
    transform: "translate(-115.244 -216.975)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47849",
    "data-name": "Path 47849",
    d: "M124.855,375.442a3.816,3.816,0,0,1-1.623-.4.13.13,0,0,1-.062-.111.12.12,0,0,1,.062-.1c.056-.031,1.358-.753,2.08-.506a.673.673,0,0,1,.42.389.44.44,0,0,1-.093.543,1.214,1.214,0,0,1-.784.185Zm-1.284-.512a2.628,2.628,0,0,0,1.907.13c.043-.037.093-.1.025-.259a.422.422,0,0,0-.265-.247A2.832,2.832,0,0,0,123.571,374.929Z",
    transform: "translate(-115.243 -216.639)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47850",
    "data-name": "Path 47850",
    d: "M118.687,370.83l-2.963-5.259a.42.42,0,0,0-.519-.2l-4.376,1.679a.841.841,0,0,0-.383,1.2c1.062,1.815,1.667,2.642,2.969,4.951.8,1.42,2.037,4.525,2.988,6.568.926,2,2.963,1.241,2.747.309a18.609,18.609,0,0,1-.3-8.321,1.406,1.406,0,0,0-.16-.938Z",
    transform: "translate(-110.329 -213.225)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47851",
    "data-name": "Path 47851",
    d: "M189.849,406.947a8.654,8.654,0,0,1-1.66-.191.132.132,0,0,1-.1-.1.124.124,0,0,1,.068-.13c.241-.123,2.389-1.2,3.025-.846a.4.4,0,0,1,.2.333.718.718,0,0,1-.241.611,2.044,2.044,0,0,1-1.29.321Zm-1.247-.364a3.393,3.393,0,0,0,2.364-.148.456.456,0,0,0,.154-.407.133.133,0,0,0-.074-.13c-.352-.2-1.568.265-2.444.679Z",
    transform: "translate(-140.09 -228.632)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47852",
    "data-name": "Path 47852",
    d: "M188.2,405.991a.194.194,0,0,1-.074-.025.118.118,0,0,1-.049-.117c.012-.093.253-2.259,1.438-2.259h.1c.346.037.438.21.463.346.1.6-1.185,1.747-1.827,2.031a.145.145,0,0,1-.049.012Zm1.321-2.148c-.765,0-1.062,1.259-1.16,1.8.66-.4,1.531-1.3,1.475-1.654,0-.031-.019-.117-.241-.136h-.074Z",
    transform: "translate(-140.086 -227.862)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47853",
    "data-name": "Path 47853",
    d: "M183.3,406.28h-5.944a.432.432,0,0,0-.432.364l-.8,4.7a.832.832,0,0,0,.827.944c2.074-.037,3.074-.154,5.691-.154,1.611,0,4.932.167,7.154.167s2.395-2.2,1.475-2.395c-4.123-.9-5.728-2.123-7.092-3.3a1.365,1.365,0,0,0-.877-.327Z",
    transform: "translate(-135.507 -228.891)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16194",
    "data-name": "Group 16194",
    transform: "translate(8.908 147.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47854",
    "data-name": "Path 47854",
    d: "M185.975,387.589l-.877,6.753-5.228-.877.809-6.265Z",
    transform: "translate(-145.852 -368.861)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47855",
    "data-name": "Path 47855",
    d: "M129.038,357.49l3.592,3.988-4.148,2.864-3.722-3.895Z",
    transform: "translate(-124.76 -357.49)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47856",
    "data-name": "Path 47856",
    d: "M174.281,192.625l21.425,2.876c8.3-30.055,5.852-30.87,5.852-30.87a43.682,43.682,0,0,0-4.938-1.957c-.1-.037-.2-.062-.3-.093-1.383-.414-1.673-.475-3.518-.9-3.16-.556-6.1-.988-9.728-1.3-.235-.019-.463-.043-.691-.056-.654-.043-1.3-.074-1.932-.1-.426-.025-.846-.025-1.247-.031h-1.37c-.247,0-.488,0-.716.012a2.968,2.968,0,0,0-2.883,3.309c1.827,15.808,1.241,21.006.043,29.1Z",
    transform: "translate(-134.781 -134.709)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47857",
    "data-name": "Path 47857",
    d: "M210.03,177.391c.148,1.4,3.37,3.944,4.481,3.253.327-1.667.556-3.062.722-4.222-1.636-.117-4.8-1.907-5.2.969Z",
    transform: "translate(-148.488 -140.666)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47858",
    "data-name": "Path 47858",
    d: "M204.369,165.782c-.154-4.92,11.814.5,14.561,1.728l-3.037,8.259a16.92,16.92,0,0,1-6.555-1.611,10.353,10.353,0,0,1-4.963-8.37Z",
    transform: "translate(-146.32 -136.069)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47859",
    "data-name": "Path 47859",
    d: "M191,130.319c.4,5.222.451,7.438,3.148,10.148,4.062,4.08,10.444,2.636,11.629-2.549,1.068-4.673.241-12.426-4.951-14.574A7,7,0,0,0,191,130.319Z",
    transform: "translate(-141.195 -120.377)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47860",
    "data-name": "Path 47860",
    d: "M180.508,123.327c-5.247-1.309-5.407,3.117-5.3,5.407s-3.747,3.432-3.747,6.339c0,3.79,2.858,6.049-4.092,7.2-5.889.969-7.7,8.321,1.006,12.623,9.636,4.759,24.172-1.938,22.4-8.3-2.728-9.821,2.154-9.79,1.6-15.271-.4-3.988,3.376-4.185,2.018-7.512-1.778-4.364-14.358-8.191-13.895-.481Z",
    transform: "translate(-130.255 -118.903)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47861",
    "data-name": "Path 47861",
    d: "M181.683,132.9c-.722-3.8-.327-6.321,1.173-7.5,1.932-1.518,4.9-.2,5.031-.142l-.253.562s-2.759-1.222-4.395.068c-1.3,1.025-1.623,3.346-.944,6.895l-.6.117Z",
    transform: "translate(-137.504 -121.11)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47862",
    "data-name": "Path 47862",
    d: "M169.841,151.451a12,12,0,0,1-3.951-.8l.228-.574c.043.019,4.2,1.648,6.123.056.938-.778,1.2-2.241.8-4.339l.6-.117c.457,2.339.117,4-1.006,4.932a4.319,4.319,0,0,1-2.8.839Z",
    transform: "translate(-131.594 -129.151)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47863",
    "data-name": "Path 47863",
    d: "M208.682,137.713a4.747,4.747,0,0,0,.722,2.765c.716,1.167,1.685.951,2-.037a3.534,3.534,0,0,0-.71-3.42c-.951-.833-1.914-.389-2.012.691Z",
    transform: "translate(-147.966 -125.672)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47864",
    "data-name": "Path 47864",
    d: "M171.387,214.843s-8.321,35.166-12.21,55.363c-4.1,21.314-28.394,38.7-28.394,38.7l-5.333-5.488s15.642-13.691,19.66-33.592c8.154-40.394,2.636-48.53,10.506-57.1l15.771,2.117Z",
    transform: "translate(-116.116 -154.81)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47865",
    "data-name": "Path 47865",
    d: "M130.7,364.334l-6.66-6.852,1.87-2.012,7.734,6.808Z",
    transform: "translate(-115.576 -209.445)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47866",
    "data-name": "Path 47866",
    d: "M189.29,227.938c-6.469,5.617-5.771,25.543-5.092,34.524,2.716-12.771,5.975-26.987,7.889-35.215C191.408,226.735,190.475,226.908,189.29,227.938Z",
    transform: "translate(-138.439 -160.263)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47867",
    "data-name": "Path 47867",
    d: "M196.828,216.111s3.741,41.746,1.7,57.671c-2.123,16.561-12.932,52.6-12.932,52.6l-7.629-.988s6.2-35.709,7.3-52.11c1.2-17.876-4.13-59.282-4.13-59.282l15.691,2.1Z",
    transform: "translate(-136.217 -155.3)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47868",
    "data-name": "Path 47868",
    d: "M186.206,393.907,175.33,392.5l.167-3.21,11.8,1.142Z",
    transform: "translate(-135.207 -222.389)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16195",
    "data-name": "Group 16195",
    transform: "translate(38.121 56.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47869",
    "data-name": "Path 47869",
    d: "M173.28,210.568l-1.167,1.772c-.093.136.068.315.315.346L194.9,215.7c.191.025.364-.049.389-.167l.4-1.876c.025-.13-.13-.265-.339-.29l-21.7-2.914a.387.387,0,0,0-.364.111Z",
    transform: "translate(-172.087 -210.453)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47870",
    "data-name": "Path 47870",
    d: "M173.28,210.568l-1.167,1.772c-.093.136.068.315.315.346L194.9,215.7c.191.025.364-.049.389-.167l.4-1.876c.025-.13-.13-.265-.339-.29l-21.7-2.914a.387.387,0,0,0-.364.111Z",
    transform: "translate(-172.087 -210.453)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47871",
    "data-name": "Path 47871",
    d: "M177.848,213.445l-.58-.08c-.117-.019-.2-.086-.179-.16l.537-2.438c.019-.074.123-.117.241-.1l.58.08c.117.019.2.086.179.16l-.537,2.438C178.07,213.42,177.965,213.464,177.848,213.445Z",
    transform: "translate(-135.879 -154.022)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47872",
    "data-name": "Path 47872",
    d: "M201.628,216.7l-.58-.08c-.117-.019-.2-.086-.179-.16l.537-2.438c.019-.074.123-.117.241-.1l.58.08c.117.019.2.086.179.16l-.537,2.438C201.85,216.67,201.745,216.714,201.628,216.7Z",
    transform: "translate(-144.98 -155.266)",
    fill: "#263238"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent83);
export default __webpack_public_path__ + "static/media/Component83.ee1ce8e162903c996d230bc99e1f0043.svg";
export { ForwardRef as ReactComponent };